import React, { useEffect, useState } from "react";
import { handleloading } from "../../../Store/Redux/Reducers/Dashboardreducers";
import { ViewUserService } from "../../../Services/ApiServices";
import {
  CatchMessage,
  JSONtoformdata,
  MomentDateTime,
  getValidData,
  tokenisValid,
} from "../../../Shared/Methods";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../../Store/Redux/Reducers/Authreducers";
import { useDispatch, useSelector } from "react-redux";
import classes from "./userprofile.module.css";
import manimage from "../../../Assests/Images/man.png";
import Loader from "../../../SharedComponents/Loader/Loader";
import { Col, Row } from "antd";
import UserCreateModal from "../../../Modals/User/UserCreateModal";
import userediticon from "../../../Assests/Icons/edit (4).png";

function UserProfile() {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);
  const dispatch = useDispatch();
  const [userData, setUserData] = useState<any>();
  const [showModal, setShowModal] = useState<any>({
    isView: false,
    item: "",
    create: "",
  });

  useEffect(() => {
    if (LoginData !== null) {
      getVieUser();
    }
  }, [LoginData]);

  const getVieUser = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };

    ViewUserService(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status === 1) {
          setUserData(res?.data?.data);
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const image = userData?.image ? userData?.image.split("/")[1] : "";

  const handleCancel = () => {
    setShowModal({
      isView: false,
      item: "",
      create: "",
    });
  };

  return (
    <>
      {showModal?.isView ? (
        <UserCreateModal
          handleSuccess={() => {
            getVieUser();
          }}
          Action={showModal?.create}
          onCancel={handleCancel}
          item={showModal?.item}
          closable={!showModal?.isView}
          open={showModal?.isView}
          // DropDowns={DropDowns}
          // DropdownMethods={{
          //   getBaudrateDropDown,
          //   getParityDropDown,
          //   getDataBitsDropDown,
          // }}
        />
      ) : null}

      <Loader isLoader={loading} />
      {/* <div style={{ position: "relative" }}>
        <div className={classes.profile_bg_container}>
          <div className={classes.small_circle}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div> */}

      {/* <Usertopbackground /> */}

      <div style={{ position: "relative" }}>
        <div>
          <div
            className={`${classes.profile_container} ${classes.fadeInTop} 
            `}
          >
            {/* <img src={manimage} className={classes.user_image_container} /> */}
            <div>
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <h3 style={{ margin: 0 }}>Profile</h3>
                  {/* <CommonButton
                    type="button"
                    onClick={() => {
                      setShowModal({
                        isView: true,
                        item: userData,
                        action: "Update",
                      });
                    }}
                    name="Update"
                    classname="submit_btn"
                  /> */}
                  <img
                    src={userediticon}
                    alt="userediticon"
                    style={{ width: "35px" }}
                    className={classes.flipOutY}
                    onClick={() => {
                      setShowModal({
                        isView: true,
                        item: userData,
                        action: "Update",
                      });
                    }}
                  />
                </div>

                {/* <p className={classes.user_name_style}>{userData?.name}</p> */}

                <div className={classes.keypairs}>
                  <Row
                    gutter={[16, 16]}
                    className={classes.profilerowcontainer}
                  >
                    <Col
                      xxl={6}
                      xl={6}
                      lg={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className={classes.user_image_container_two}>
                        <img src={manimage} className={classes.user_image} />
                      </div>
                    </Col>
                    <Col
                      xxl={18}
                      xl={18}
                      lg={12}
                      md={12}
                      style={{ marginTop: "24px" }}
                    >
                      <p className={classes.user_name_style}>
                        {getValidData(userData?.name)}
                      </p>
                      <Row
                        gutter={[16, 16]}
                        className={classes.user_details_cotent}
                      >
                        {/* <Col xxl={24} lg={24} md={24} sm={24}>
                          <p className={classes.user_name_style}>
                            {getValidData(userData?.name)}
                          </p>
                        </Col> */}
                        <Col xxl={12} xl={12} lg={24} md={24} sm={12} xs={24}>
                          <h6>
                            User Name:{" "}
                            <span>{getValidData(userData?.username)}</span>
                          </h6>
                        </Col>
                        <Col xxl={12} xl={12} lg={24} md={24} sm={12} xs={24}>
                          <h6>
                            E-mail: <span>{getValidData(userData?.email)}</span>
                          </h6>
                        </Col>
                        <Col xxl={12} xl={12} lg={24} md={24} sm={12} xs={24}>
                          <h6>
                            Mobile: <span>{getValidData(userData?.phone)}</span>
                          </h6>
                        </Col>

                        <Col xxl={12} xl={12} lg={24} md={24} sm={12} xs={24}>
                          <h6>
                            Alternative Mobile:{" "}
                            <span>
                              {getValidData(userData?.alternativeNumber)}
                            </span>
                          </h6>
                        </Col>

                        <Col xxl={12} xl={12} lg={24} md={24} sm={12} xs={24}>
                          <h6>
                            Created At:{" "}
                            <span>
                              {getValidData(
                                userData?.created_at
                                  ? MomentDateTime(userData?.created_at)
                                  : ""
                              )}
                            </span>
                          </h6>
                        </Col>
                      </Row>
                    </Col>

                    {/* <Col xxl={18}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <p className={classes.user_name_style}>{userData?.name}</p>

                    <h6>
                      User Name: <span>{userData?.username}</span>
                    </h6>
                    <h6>
                      E-mail: <span>{userData?.email}</span>
                    </h6>
                    <h6>
                      Mobile: <span>{userData?.mobile}</span>
                    </h6>
                    <h6>
                      Alternative Mobile:{" "}
                      <span>{userData?.alternativeNumber}</span>
                    </h6>
                    <h6>
                      Created at: <span>{userData?.created_at}</span>
                    </h6>
                  </div>
                </Col> */}
                  </Row>
                </div>

                {/* <div className={classes.keypairs}>
              <Row gutter={[16, 16]}>
                <Col xxl={12}>
                  <div style={{ display: "flex" }}>
                    <h6>
                      User Name: <span>{userData?.username}</span>
                    </h6>
                  </div>
                </Col>
                <Col xxl={12}>
                  <div style={{ display: "flex" }}>
                    <h6>
                      E-mail: <span>{userData?.email}</span>
                    </h6>
                  </div>
                </Col>
                <Col xxl={12}>
                  <div style={{ display: "flex" }}>
                    <h6>
                      Mobile: <span>{userData?.mobile}</span>
                    </h6>
                  </div>
                </Col>
                <Col xxl={12}>
                  <div style={{ display: "flex" }}>
                    <h6>
                      Alternative Mobile:{" "}
                      <span>{userData?.alternativeNumber}</span>
                    </h6>
                  </div>
                </Col>

                <Col xxl={12}>
                  <div style={{ display: "flex" }}>
                    <h6>
                      Created at: <span>{userData?.created_at}</span>
                    </h6>
                  </div>
                </Col>
              </Row>
            </div> */}

                {/* <div className={classes.keypairs}>
              <Row gutter={[16, 16]}>
                <Col xxl={8}>
                  <div className={classes.profile_content}>
                    <h6>User Name:</h6>
                    <p>{userData?.username}</p>
                  </div>
                </Col>
                <Col xxl={8}>
                  <div className={classes.profile_content}>
                    <h6>E-mail:</h6>
                    <p>{userData?.email}</p>
                  </div>
                </Col>
                <Col xxl={8}>
                  <div className={classes.profile_content}>
                    <h6>Mobile:</h6>
                    <p>{userData?.mobile}</p>
                  </div>
                </Col>
                <Col xxl={8}>
                  <div className={classes.profile_content}>
                    <h6>Alternative Mobile: </h6>
                    <p>{userData?.alternativeNumber}</p>
                  </div>
                </Col>

                <Col xxl={8}>
                  <div className={classes.profile_content}>
                    <h6>Created at:</h6>
                    <p>{userData?.created_at}</p>
                  </div>
                </Col>
              </Row>
            </div> */}

                {/* <div className={classes.keypairs}>
              <h6>
                User Name: <span>{userData?.username}</span>
              </h6>
              <h6>
                E-mail: <span>{userData?.email}</span>
              </h6>
              <h6>
                Mobile: <span>{userData?.mobile}</span>
              </h6>
              <h6>
                Alternative Mobile: <span>{userData?.alternativeNumber}</span>
              </h6>
              <h6>
                Created at: <span>{userData?.created_at}</span>
              </h6>
            </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserProfile;
